<template>
    <div class="flex items-center justify-center">
        <span class="font-medium tracking-wide font-mono">{{timerDisplayTime}}</span>
    </div>
</template>
<script>
    import timerMixin from '@/mixins/timerMixin'
    import {getInitialTime} from '@/util/timeUtils'

    export default {
        props: {
            call: {
                type: Object,
                default: () => ({})
            },
            textColor: {
                type: String,
                default: () => 'text-gray-500'
            }
        },
        mixins: [
            timerMixin
        ],
        data() {
            let initialTimeInSeconds = getInitialTime(this.call.JoinTimeStamp_UTC_CLIENT)

            return {
                timerState: {
                    seconds: initialTimeInSeconds
                },
            }
        },
        methods: {
            getTimerValue() {
                return getInitialTime(this.call.JoinTimeStamp_UTC_CLIENT)
            }
        },
        mounted() {
            this.startTimer()
        }
    }
</script>
